<template>
    <div class="">
        <gofix-card classContent="mt-4 mb-2">
            <b-row class="mb-4">
                <b-col md="4">
                    <gofix-text-field classLabel="width-99" label="Contract" oneline>
                        {{ pvItem && pvItem.contract && pvItem.contract.contract_name ? pvItem.contract.contract_name : "--"}}
                    </gofix-text-field>
                </b-col>
                <b-col md="4">
                    <gofix-text-field  classLabel="width-99" label="Created On" oneline>
                        {{ pvItem.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY","--") }}
                    </gofix-text-field>
                </b-col>
                <b-col md="4">
                    <gofix-text-field  classLabel="width-99" label="Created By" oneline>
                        {{pvItem.get_created_by ? pvItem.get_created_by.name : "--" }}
                    </gofix-text-field>
                </b-col>
            </b-row>
            <b-row class="mb-4">
                <b-col md="4">
                    <gofix-text-field classLabel="width-99" label="Pay To" oneline>
                        {{pvItem.pay_to_name || "--"}}
                    </gofix-text-field>
                </b-col>
<!--                <b-col md="4">-->
<!--                    <gofix-text-field  classLabel="width-99" label="Doc Type" oneline>-->
<!--                        {{pvItem.doc_type || "&#45;&#45;"}}-->
<!--                    </gofix-text-field>-->
<!--                </b-col>-->
                <b-col md="4">
                    <gofix-text-field classLabel="width-99" label="Doc Date" oneline>
                        {{ pvItem.doc_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY","--") }}
                    </gofix-text-field>
                </b-col>
            </b-row>
            <b-row class="mb-4">
                <b-col md="4">
                    <gofix-text-field classLabel="width-99" label="Source Doc No" oneline>
                        {{pvItem.source_doc_no || "--"}}
                    </gofix-text-field>
                </b-col>
                <b-col md="4">
                    <gofix-text-field  classLabel="width-99" label="Source Doc Date" oneline>
                        {{ pvItem.source_doc_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY","--") }}
                    </gofix-text-field>
                </b-col>
                <b-col md="4">
                    <gofix-text-field classLabel="width-99" label="Remarks" oneline>
                        {{pvItem.remark}}
                    </gofix-text-field>
                </b-col>
            </b-row>
            <b-row class="mb-4">
                <b-col md="12">
                    <gofix-text-field classLabel="width-99" label="Approval Template" oneline>
                        {{ showApprovalTitle }}
                    </gofix-text-field>
                </b-col>
            </b-row>
        </gofix-card>

        <div class="boxShadow noOverflow bg-white mb-3 pl-0 pr-0 pt-4 pb-0">
            <div class="title mb-2 pl-4 pr-4">Line Items</div>
            <gofix-default-table
                    class="noFullHeight scrollAbsolute"
                    tableClass="mb-4"
                    :settings="lineItem.tableConfig"
                    :table-items="lineItem.tableItems"
                    @load-items="getTableData"
                    ref="gofixTable">
                <template slot="gofix_table:item_doc_date" slot-scope="row">
                    {{row.item.item_doc_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                </template>
                <template slot="gofix_table:item_amount" slot-scope="row">
                    {{row.item.item_amount | formatMoney}}
                </template>
                <template slot="gofix_table:item_tax" slot-scope="row">
                    {{row.item.item_tax | formatMoney}}
                </template>
                <template slot="gofix_table:item_total" slot-scope="row">
                    {{row.item.item_total | formatMoney}}
                </template>
                <template slot="gofix_table:bottom-row" slot-scope="row">
                    <template v-for="field in row.data.fields">
                        <td class="title font-14"
                            v-bind:class="(field.key === 'item_description' || field.key === 'item_total' || field.key === 'item_amount'|| field.key === 'item_tax') ? field.tdClass : ''">
                            <span v-if="field.key === 'item_description'">Total</span>
                            <span v-if="field.key === 'item_total'">{{pvItem.total | formatMoney}}</span>
                            <span v-if="field.key === 'item_amount'">{{pvItem.amount | formatMoney}}</span>
                            <span v-if="field.key === 'item_tax'">{{pvItem.tax | formatMoney}}</span>
                        </td>
                    </template>
                </template>
            </gofix-default-table>
        </div>

      <gofix-attachment :Item="pvItem"
                        :attachable_type="'credit_note'"
                        title="Attachments" classCard="mb-0"
                        classHeaderCard="pl-4"
                        :isFixed="false"></gofix-attachment>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import attachment from '@/views/attachments/list';
    import { filters } from '@/_filterVar.js';
    import moment from 'moment';
    export default {
        name: 'payment-voucher-info',
        components: {
            attachment
        },
        data() {
            let filter =  JSON.parse(JSON.stringify(filters['credit_note_items']));
            return {
                lineItem:{
                    tableConfig:{
                        name: 'credit-note-line-items',
                        controls:{
                            create: false,
                            delete: false
                        },
                        filter: filter,
                        page: 1,
                        limit: 100,
                        total: 0,
                        useDatabaseView: true,
                        sortColumn: "line_number",
                        sortDirection: "asc",
                    },
                    tableItems: [],
                },
            }
        },
        watch: {
        },
        computed: {
            ...mapGetters({
                pvItem: "CreditNoteController/Item",
            }),
            showApprovalTitle() {
                if ( this.pvItem && this.pvItem.approval_template) {
                    const approval_template = this.pvItem.approval_template
                    let title = (approval_template.approval_process ? approval_template.approval_process.reference_value_text : '') + ' - ' + (approval_template.location ? approval_template.location.name : '')
                    if(approval_template.effective_date) title += ` (${moment(approval_template.effective_date).format("DD.MM.YYYY")})`;
                    return title;
                }

                return '---';
            },
        },
        methods: {
            /* ---- Get data ----------------------------------------------------*/
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.header_id.value = this.$route.params.credit_note_id;
                await this.$store.dispatch("CreditNoteController/getLineItems", tableRequest)
                    .then(response => {
                        this.lineItem.tableItems = response.items;
                        this.lineItem.tableConfig.total = response.total;
                        this.$emit('checkLineItemIsNull',response.items.length == 0 ?  true : false );
                        resolve(response);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
        }
    }
</script>
